import { Component } from 'react';
import ComplexMetaDataTable from './complex-meta-data-table';
import './meta-data.css';

class MetaData extends Component {
  prepareLabel(str) {
    return (
      str.replace(/_/g, ' ').replace(/\w\S*/g, function (txt) {
        return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
      }) + ': '
    );
  }

  prepareGameSummary(str) {
    const toReturn = [];
    const parsedDataArray = str.split('@');

    for (const index in parsedDataArray) {
      const dataSet = parsedDataArray[index];
      const parsedDataSet = dataSet.split(',');

      toReturn.push({
        Word: parsedDataSet[0],
        Done:
          parsedDataSet[1] === 'true' ? (
            <i class="fa fa-check game_summary_success"></i>
          ) : (
            <i class="fa fa-times game_summary_fail"></i>
          ),
        'Wrong Letter Selections': parsedDataSet[2],
        Duration: parsedDataSet[3],
      });
    }

    return toReturn;
  }

  prepareValue(str) {
    if (typeof str === 'string' && str.toLowerCase() === 'lettres') {
      str = 'Letters';
    }

    return str;
  }

  render() {
    const { data, showing } = this.props;
    let metaHTML = [];
    const complexMetaHTML = [];

    let className = 'meta_data_container';

    if (showing) {
      className += ' show';
    }

    if (!data || typeof data !== 'object') {
      metaHTML = <div>No Additional Info Available</div>;
    } else if (Object.keys(data).length === 0) {
      metaHTML = <div>No Additional Info Available</div>;
    }

    for (const key in data) {
      let value = data[key];
      if (typeof value === 'object') {
        value = value[0];
      }

      if (typeof value === 'object') {
        complexMetaHTML.push(<ComplexMetaDataTable data={value}></ComplexMetaDataTable>);
        continue;
      }

      const parsedKey = this.prepareLabel(key);

      if (parsedKey === 'Game Summary: ') {
        value = this.prepareGameSummary(value);
        complexMetaHTML.push(<ComplexMetaDataTable data={value}></ComplexMetaDataTable>);
        continue;
      }

      metaHTML.push(
        <div className="meta_data_row">
          <span className="meta_data_row_key">{parsedKey}</span>
          <span className="meta_data_row_value">{this.prepareValue(value)}</span>
        </div>
      );
    }

    return (
      <div className={className}>
        {metaHTML} {complexMetaHTML}
      </div>
    );
  }
}

export default MetaData;
